// Central site configuration — change contact info once, globally.
// Placeholder values are clearly marked; replace with real details when available.

export const SITE = {
  brand: "Dentel Vietnam",
  brandShort: "DV",
  domain: "https://dentel-vietnam.com",
  // --- Contact (PLACEHOLDERS — update when real details are available) ---
  whatsappNumber: "+84000000000", // digits only after +, used for wa.me link
  whatsappDisplay: "+84 00 000 0000",
  email: "hello@dentel-vietnam.com",
  phone: "+84 00 000 0000",
  address: {
    line1: "Dentel Vietnam",
    line2: "International Patient Support",
    city: "Ho Chi Minh City",
    country: "Vietnam",
  },
  social: {
    facebook: "https://facebook.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://linkedin.com/",
  },
  languages: ["en", "fr", "de"],
  defaultLanguage: "en",
};

export const WHATSAPP_LINK = (message = "") => {
  const num = SITE.whatsappNumber.replace(/[^0-9]/g, "");
  const q = message ? `?text=${encodeURIComponent(message)}` : "";
  return `https://wa.me/${num}${q}`;
};

export const LANG_LABELS = {
  en: { code: "EN", label: "English", flag: "🇬🇧" },
  fr: { code: "FR", label: "Français", flag: "🇫🇷" },
  de: { code: "DE", label: "Deutsch", flag: "🇩🇪" },
};
